import { requestCommitmentStatuses } from 'legacy/lut/features/partner360/commitment'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import { TAppDispatch } from 'legacy/lut/hooks/useAppDispatch'

interface IRecalculateCompleteness {
  pid: string
  fYear: number
  dispatch: TAppDispatch
}

export const recalculateCompleteness = ({ pid, fYear, dispatch }: IRecalculateCompleteness) => {
  const parameters = {
    partnerId: pid,
    fYear,
  }

  const recalculation = dispatch(requestRecalculateCompleteness(parameters))
  dispatch(requestCommitmentStatuses(parameters))

  return recalculation
}
